type PendingRequest = {
    res: any;
    rej: any;
    promise: any;
};

//** temp (ts doesn't recognize this type probably because of the outdated typescript version in root)
type WindowPostMessageOptions = any;

interface PendingRequestController {
    [key: number]: PendingRequest;
}

export default class InlineWorkerThread extends Worker {
    #req_count: number = 0;
    #requests: PendingRequestController = {};

    constructor(fn: (...args: any) => any) {
        let blob = new Blob(['onmessage = ' + fn.toString()], { type: 'application/js' }),
            url = URL.createObjectURL(blob);
        super(url);

        this.addEventListener('message', this.msg);
    }

    run(hook: string, payload: any, options?: WindowPostMessageOptions) {
        let req_n = ++this.#req_count,
            req: any = {};

        req.promise = new Promise(async (res: any, rej: any) => {
            req.res = res;
            req.rej = rej;
        }).catch((err: any) => {
            //
        });
        this.#requests[req_n] = req as PendingRequest;

        this.postMessage({ req_n, hook, payload }, options);

        return this.#requests[req_n].promise;
    }

    msg({ data: { req_n, hook, payload } }: MessageEvent) {
        if (hook === 'reject') {
            this.#requests[req_n]?.rej('Killing Promise');
        } else this.#requests[req_n]?.res(payload);
        delete this.#requests[req_n];
    }
}

/** use ex */
// // this func is run on the worker thread
//const worker = new InlineWorkerThread((data: any) => {

//   if (data === 'freeze!') {
//      let i = 0
//      while(++i < 10000000) {
//         // freeze
//      }
//       postMessage('done loopin')
//   }
//})

// // here we talk to the worker thread
// worker.run('freeze!').then((data: any) => {
//
// })
